import { apiRequest } from './client.js';
import type { SupportSnapshot } from '@hisob/types';
import type { DecryptedSnapshotData } from '../types/index.js';

export async function fetchSnapshots(): Promise<SupportSnapshot[]> {
  const res = await apiRequest<{ items: SupportSnapshot[] }>('/api/v1/admin/snapshots');
  return res.items || [];
}

export async function inspectSnapshot(id: string, reason: string): Promise<DecryptedSnapshotData> {
  return apiRequest<DecryptedSnapshotData>(`/api/v1/admin/snapshots/${id}`, {
    params: { reason },
  });
}

export async function deleteSnapshot(id: string): Promise<{ success: boolean }> {
  return apiRequest<{ success: boolean }>(`/api/v1/admin/snapshots/${id}`, {
    method: 'DELETE',
  });
}

